import { render, staticRenderFns } from "./policy-category-badge.vue?vue&type=template&id=0255d25c"
import script from "./policy-category-badge.vue?vue&type=script&lang=js"
export * from "./policy-category-badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports